module.exports = __webpack_public_path__ + "static/media/personalizado_2.f07a5562.png";